import * as types from "../types";

const dumpData = {
    cardType: "",
    firstName: "",
    middleName: "",
    lastName: "",
    employeeNumber: "",
    officialEmailId: "",
    mobileNo: "",
    companyName: "",
    employeeGrade: "",
    designation: "",
    officeAddressLine1: "",
    officeAddressLine2: "",
    officeAddressLine3: "",
    officeLandmark: "",
    officePin: "",
    resiCurrentAddressline1: "",
    resiCurrentAddressline2: "",
    resiCurrentAddressline3: "",
    resiLandmark: "",
    resiPin: "",
    personalEmailId: "",
    employeeEmployeementStatus: "",
    panNumber :"",
    dob :"",
    motherName :"",
    emailId :"",
    natureOfCompany :"",
    occupation : "",
}
const initState = {
    isDumpData: null,
    dumpData : dumpData,
    resiAddress:null,
    officeAddress:null,
    emvTriggered: null,
    emvSentDate:null,
    emvResponseDate:null,
    cardNumber:null
};

const DumpDataReducer = (state = initState, action) => {
    switch (action.type) {
        case types.SAVE_IS_DUMP_BASED:
            return {
                ...state,
                isDumpData: action.payload
            }
        case types.SAVE_CORPORATE_DUMP_DATA:
            return {
                ...state,
                dumpData: action.payload,
            }
        case types.SAVE_CORP_OTP_AUTH_MODE:
                    return{
                        ...state,
                        emvTriggered : "Y"  ,
                        emvSentDate : action.payload.corpEmailOtpSentTime,
                        cardNumber : action.payload.cardNumber
                    }
        case types.SAVE_CORP_OTP_VALIDATE_TIME:
                    return{
                        ...state,
                        emvResponseDate :  action.payload ,
                    }            
        default:
        return state;
    }
};

export default DumpDataReducer;
